<template>
  <div v-if="isPreview" class="flex h-[45px] cursor-pointer items-center justify-center rounded-xs bg-[#ffc439]">
    <div class="h-[22px]">
      <img
        src="data:image/svg+xml;base64,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"
        alt=""
        aria-label="PayPal"
        class="h-full"
      />
    </div>
  </div>
  <div v-else-if="loading" class="flex items-center justify-center">
    <LoaderIcon class="h-4 w-4" />
  </div>
  <div v-else id="paypal-button-container" :class="{ 'opacity-50': disabled }" />
</template>

<script>
import { loadScript } from '@paypal/paypal-js'
import axios from 'axios'

import LoaderIcon from '@/Components/LoaderIcon.vue'
import route from '@/Util/route.js'

export default {
  components: {
    LoaderIcon,
  },
  inject: ['paypalClientId', 'paypalScriptIntent', 'isApi', 'isInitialized'],
  props: {
    store: {
      type: Object,
      required: true,
    },
    cspNonce: {
      type: String,
      required: true,
    },
    cart: {
      type: Object,
      required: true,
    },
    country: {
      type: String,
      required: true,
    },
    postalCode: {
      type: String,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    isPreview: {
      type: Boolean,
      default: false,
    },
    selectedPaymentMethod: {
      type: String,
    },
  },
  emits: ['working', 'success'],
  data() {
    return {
      loading: false,
      working: false,
      planId: null,
      isReady: false,
    }
  },
  computed: {
    paypalCartData() {
      return {
        selectedPaymentMethod: this.selectedPaymentMethod,
        cartPriceId: this.cart.items[0].price_id,
        cartDiscountId: this.cart.discount_id,
        cartTaxRate: this.cart.tax_rate,
      }
    },
    paypalQuantity() {
      const cartItem = this.cart.items[0]
      const priceModel = cartItem.price_model
      return priceModel.scheme === 'package'
        ? Math.ceil(cartItem.quantity / priceModel.package_size)
        : cartItem.quantity
    },
  },
  watch: {
    working(newVal) {
      this.$emit('working', newVal)
    },
    paypalCartData: {
      handler: async function (newVal) {
        if (newVal.selectedPaymentMethod === 'paypal') {
          this.setupPayPal()
        }
      },
      deep: true,
    },
    isInitialized() {
      this.setupPayPal()
    },
  },
  mounted() {
    if (this.isPreview) {
      return
    }

    this.setupPayPal()
  },
  methods: {
    setupPayPal() {
      if (!this.isInitialized) {
        return
      }

      if (!this.isReady) {
        this.loading = true
      }

      this.getSubscriptionPlan().then(() => {
        if (!this.isReady) {
          this.loading = false
          this.isReady = true

          this.$nextTick(() => {
            this.initPayPalButtons()
          })
        }
      })
    },
    $route(name) {
      if (this.isApi) {
        return route(
          `spa-api.${name}`,
          {
            cart: this.cart.id,
          },
          undefined,
        )
      }

      return route(
        name,
        {
          domain: this.store.url_domain,
          cart: this.cart.id,
        },
        undefined,
      )
    },
    getSubscriptionPlan() {
      return axios
        .post(
          this.$route('checkout.paypal.subscription.plan'),
          {
            cart_id: this.cart.id,
          },
          {
            headers: {
              'X-Secret': this.cart.secret,
            },
          },
        )
        .then((response) => {
          this.planId = response.data.plan_id
        })
        .catch((error) => {
          console.error(error)
        })
    },
    initPayPalButtons() {
      loadScript({
        'client-id': this.paypalClientId,
        'disable-funding': 'card,credit',
        vault: true,
        intent: this.paypalScriptIntent,
        'data-csp-nonce': this.cspNonce,
      })
        .then((paypal) => {
          paypal
            .Buttons({
              onInit: (data, actions) => {
                actions.disable()

                this.$watch(
                  () => this.disabled,
                  (newVal) => {
                    if (newVal) {
                      actions.disable()
                    } else {
                      actions.enable()
                    }
                  },
                )
              },
              onClick: (data, actions) => {
                if (this.disabled) {
                  return actions.reject()
                }
                return this.$parent
                  .validate()
                  .then(() => {
                    // Refresh the plan here in case the amount or tax has changed
                    return this.getSubscriptionPlan()
                  })
                  .then(() => {
                    return actions.resolve()
                  })
                  .catch(() => {
                    return actions.reject()
                  })
              },
              createSubscription: (data, actions) => {
                this.working = true
                return axios
                  .post(
                    this.$route('checkout.authorize', {
                      domain: this.store.url_domain,
                    }) + `?cart=${this.cart.id}`,
                    {
                      country: this.country,
                      postal_code: this.postalCode,
                      service: 'paypal',
                    },
                    {
                      headers: {
                        'X-Secret': this.cart.secret,
                      },
                    },
                  )
                  .then(() => {
                    return actions.subscription.create({
                      plan_id: this.planId,
                      custom_id: this.cart.id,
                      quantity: this.paypalQuantity,
                    })
                  })
                  .catch((error) => {
                    console.error(error)
                  })
                  .finally(() => {
                    this.working = false
                  })
              },
              onApprove: (data, actions) => {
                return axios
                  .post(
                    this.$route('checkout.paypal.subscription.store'),
                    {
                      cart_id: this.cart.id,
                      order_id: data.orderID,
                      subscription_id: data.subscriptionID,
                    },
                    {
                      headers: {
                        'X-Secret': this.cart.secret,
                      },
                    },
                  )
                  .then(() => {
                    this.$emit('success')
                  })
                  .catch((error) => {
                    console.error(error)
                    if (error.response) {
                      if (error.response.data.issue === 'INSTRUMENT_DECLINED') {
                        return actions.restart()
                      }
                      if (error.response.data.errors && error.response.data.errors.purchase_attempt) {
                        this.eventHub.emit('purchase-attempt-error', error.response.data.errors.purchase_attempt)
                        return
                      }
                    }
                  })
              },
            })
            .render('#paypal-button-container')
            .catch((err) => {
              console.error('Error rendering PayPal: ', err)
            })
        })
        .catch((err) => {
          console.error('Error loading PayPal: ', err)
        })
    },
  },
}
</script>
